/**
 * @file api-config provides promise-based HTTP abstraction with extended error
 */
import router from '@/router'
import axios from 'axios'
import { store } from '@/store'

let count = 0

const $axios = axios.create({
  // setup root url for all http requests
  baseURL: process.env.VUE_APP_API,
  // customized XMLHttpRequest wrapper library
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

// global request interceptor
$axios.interceptors.request.use((config) => {
  count++

  const token = store.state.auth.token
  const teamId = store.state.team.teamId

  // intercept url for auth
  if (token) {
    config.headers.auth = token
    config.headers.Accept = 'application/json'
  }

  if (teamId) {
    config.headers.team = teamId
  }
  return config
})

// global response interceptor
$axios.interceptors.response.use(
  response => {
    count--
    store.commit('setRequestCount')

    setTimeout(() => {
      if (count <= 0) store.commit('loading', false)
    }, 500)
    return response
  },
  error => {
    count = 0

    store.commit('loading', false)
    store.commit('toggleBookLoading', false)
    let message = error.response?.data.error.message || error
    const code = error.response?.data.error.code
    // exception for Unauthorized
    if (error.response?.status === 401 && router.currentRoute.value.name !== 'Share') {
      message = 'Your authorization token got expired'
      const url = window.location.search ? window.location.pathname + window.location.search : window.location.pathname

      router.push({ name: 'Unauthorized', params: { savedUrl: url } }).catch(() => {})
      return
    }

    if (!code || code !== 6) store.commit('setNotification', { isVisible: true, message, color: 'error' })

    return Promise.reject(error.response)
  }
)

export default $axios
